<template>
	<div class="costcenter">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">账户总览</div>
					<div class="contentcard" v-if="!loading">
						<a-row :gutter="16">
							<a-col :span="6">
								<a-card :bordered="false" style="height: 120px;">
									<div>
										<span style="color: #888;font-size: 14px;">账户状态</span>
										<span style="font-size: 20px;" v-if="sufficient_price>=0">正常</span>
										<span style="font-size: 20px;color: red;" v-else>欠费</span>
									</div>
									<div style="margin-top: 20px;">
										<span style="color: #888;font-size: 14px;display: inline-block;margin-right: 5px;">可用额度预警</span>
										<a-switch :checked="sys_site_conf.send_sms" @change="onSmsChange" />
									</div>
								</a-card>
							</a-col>
							<a-col :span="6">
								<a-card :bordered="false" style="height: 120px;">
									<div style="width: 100%;position: relative;">
										<span style="color: #888;font-size: 14px;">可用余额</span>
										<span class="click_btn" @click="voucher()">充值</span>
									</div>
									<div style="margin-top: 15px;">
										<span style="font-size: 30px;display: inline-block;margin-right: 5px;">￥{{sufficient_price/100000}}</span>
									</div>
								</a-card>
							</a-col>
							<a-col :span="6">
								<a-card :bordered="false" style="height: 120px;">
									<div style="width: 100%;position: relative;">
										<span style="color: #888;font-size: 14px;">本月服务费</span>
										<span class="click_btn" @click="particulars()">详情</span>
									</div>
									<div style="margin-top: 15px;">
										<span style="font-size: 30px;display: inline-block;margin-right: 5px;">￥{{price_this_month/100000}}</span>
									</div>
								</a-card>
							</a-col>
							<a-col :span="6">
								<a-card :bordered="false" style="height: 120px;">
									<div style="width: 100%;position: relative;">
										<span style="color: #888;font-size: 14px;">可开票金额(暂无)</span>
										<span class="click_btn">开票</span>
									</div>
									<div style="margin-top: 15px;">
										<span style="font-size: 30px;display: inline-block;margin-right: 5px;">￥0</span>
									</div>
								</a-card>
							</a-col>
						</a-row>
					</div>

				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>

		<a-modal title="可用额度预警" :visible="waring_visible" @ok="waring_Ok" :confirmLoading="waringLoading" @cancel="waring_Cancel">
			<div style="" v-if="!loading">
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 130px;text-align: right;margin-right: 20px;">可用额度预警阈值:</span>
					<a-input style="width: 100px;" v-model="sys_site_conf.waring_price" placeholder="请输入整数" />
					<span style="display: inline-block;margin-left: 10px;">元</span>
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 130px;text-align: right;margin-right: 20px;">短信通知手机号码:</span>
					<a-input style="width: 200px;" v-model="sys_site_conf.phone_number" placeholder="请输入手机号" />
				</div>
				<div style="margin: 10px 0;"><span style="color: red;display: inline-block;margin-left: 20px;">当账户余额小于阈值时进行短信提醒</span>
				</div>
			</div>
		</a-modal>

	</div>
</template>

<script>
	import moment from 'moment';
	export default {

		data() {
			return {
				current: ['accountpandect'],
				openKeys: ['costcenter'],
				loading: true,
				waringLoading: false,
				waring_visible: false,
				sys_site_conf: {
					send_sms: false
				},
				sufficient_price: 0,
				price_this_month: 0,

			}
		},
		created: function() {
			var self = this;
			var params = {
				startdate: this.moment().startOf('month').format("YYYY-MM-DD"),
				enddate: this.moment().endOf('month').format("YYYY-MM-DD"),
			};
			this.$axios.get('/costcenter/get', {
				params: params
			}).then(function(res) {
				self.sys_site_conf = res.data.sys_site_conf;
				self.sufficient_price = res.data.sufficient_price;
				self.price_this_month = res.data.price_this_month;
				self.loading = false
			});
		},
		methods: {
			moment,
			onSmsChange(checked) {
				var self = this;
				if (checked) {
					this.waring_visible = true;
				} else {
					this.$confirm({
						title: '提示',
						content: '是否关闭可用额度预警提示',
						okText: '确认',
						cancelText: '取消',
						onOk() {
							self.$axios.post('/costcenter/closesms').then(function(res) {
								self.sys_site_conf.send_sms = checked;
								self.$notification.open({
									message: '通知',
									description: res.data,
									onClose: close,
								});
							})
						},
						onCancel() {},
					});
				}
			},
			voucher() {
				this.$router.push({
					name: 'voucher'
				})
			},
			particulars() {
				var date = {
					trade_id: null,
					startdate: this.moment().startOf('month').format("YYYY-MM-DD"),
					enddate: this.moment().endOf('month').format("YYYY-MM-DD"),
				}
				this.$router.push({
					name: 'servicelist',
					query: {
						searchlist: JSON.stringify(date)
					}
				})
			},
			waring_Ok() {
				if (!this.sys_site_conf.waring_price || this.sys_site_conf.waring_price <= 0) {
					return this.$message.error("阈值不能为空或小于0");
				}
				if (!this.sys_site_conf.phone_number) {
					return this.$message.error("手机号码不能为空");
				}
				this.waringLoading = true;
				var params = {
					waring_price: this.sys_site_conf.waring_price,
					phone_number: this.sys_site_conf.phone_number,
				};
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否保存可用额度预警提示配置',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/costcenter/startsms', {
							params: params
						}).then(function(res) {
							self.sys_site_conf.send_sms = true;
							self.waring_visible = false;
							self.waringLoading = false;
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
						})
					},
					onCancel() {},
				});
			},
			waring_Cancel() {
				this.waring_visible = false;
			},

		},

	};
</script>

<style>
	.costcenter .contentcard {
		padding: 24px 8px;
		position: relative;
	}

	.costcenter .click_btn {
		color: #888;
		font-size: 14px;
		color: #1890ff;
		right: 0;
		display: inline-block;
		position: absolute;
	}

	.costcenter .click_btn:hover {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// index.vue?e55422be